/**
 * A custom Date subclass that adjusts the current time by a fixed
 * server-vs-client offset. The offset is set once during app initialization.
 *
 * With no arguments (`new ServerDate()` / `ServerDate.now()`) it returns the
 * current time adjusted by the offset. With arguments it behaves exactly like
 * the native `Date`.
 */
export class ServerDate extends Date {
  private static hasBeenSet = false
  private static differenceBetweenServerAndClientTimeMs = 0

  constructor(...args: any) {
    if (!args || !args?.length) {
      super(Date.now() + ServerDate.differenceBetweenServerAndClientTimeMs)
    } else {
      super(...(args as ConstructorParameters<typeof Date>))
    }
  }

  /** Set the server/client time gap (ms). May be called only once. */
  static setGap(gapMs: number): void {
    if (this.hasBeenSet) {
      throw new Error(
        `Time gap already set. It should be set once on init application.`
      )
    } else {
      this.differenceBetweenServerAndClientTimeMs = gapMs
      this.hasBeenSet = true
    }
  }

  /** Whether the server/client gap has already been set. */
  static isSet(): boolean {
    return ServerDate.hasBeenSet
  }

  /** Like `Date.now()` but includes the gap adjustment. */
  static now(): number {
    const currentTime = Date.now()
    return currentTime + ServerDate.differenceBetweenServerAndClientTimeMs
  }
}
